<div class="text-14 margin-top-30 margin-bottom-10" *ngIf="inceptionDateText" [innerHTML]="inceptionDateText"></div>
